"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.cssAnchorName = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _classnames = _interopRequireDefault(require("classnames"));

var _Search = _interopRequireDefault(require("./Search"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var SearchForm = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(SearchForm, _Component);

  var _super = _createSuper(SearchForm);

  function SearchForm() {
    (0, _classCallCheck2.default)(this, SearchForm);
    return _super.apply(this, arguments);
  }

  (0, _createClass2.default)(SearchForm, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          isUserGuest = _this$props.isUserGuest,
          isFederatedSkilljarSearch = _this$props.isFederatedSkilljarSearch,
          isFederatedSalesforceSearch = _this$props.isFederatedSalesforceSearch,
          isFederatedFreshdeskSearch = _this$props.isFederatedFreshdeskSearch,
          searchInContentCategories = _this$props.searchInContentCategories;
      return (0, _preact.h)("form", {
        method: "get",
        action: (0, _absoluteUrlRuntime.resolveUrl)("/search/index"),
        "data-bounded-context": "Search"
      }, (0, _preact.h)("div", {
        className: (0, _classnames.default)('searchbox', 'searchbox--large', 'qa-search-area')
      }, (0, _preact.h)("div", {
        className: (0, _classnames.default)('searchbox__input', 'algolia-search--forum', 'qa-menu-search-input')
      }, (0, _preact.h)(_Search.default, {
        isUserGuest: isUserGuest,
        searchInContentCategories: searchInContentCategories,
        isFederatedSalesforceSearch: isFederatedSalesforceSearch,
        isFederatedSkilljarSearch: isFederatedSkilljarSearch,
        isFederatedFreshdeskSearch: isFederatedFreshdeskSearch
      }))));
    }
  }]);
  return SearchForm;
}(_preact.Component);

exports.default = SearchForm;
var cssAnchorName = 'search-form';
exports.cssAnchorName = cssAnchorName;